import { render, staticRenderFns } from "./First_mobile.vue?vue&type=template&id=f0c81c12&"
import script from "./First_mobile.vue?vue&type=script&lang=js&"
export * from "./First_mobile.vue?vue&type=script&lang=js&"
import style0 from "./First_mobile.vue?vue&type=style&index=0&id=f0c81c12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports